import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

class Project {
  constructor({ el, wWidth, isMobile, index }) {
    this.wWidth = wWidth;
    this.autoPlayInterval = 5000;
    this.timer = null;
    this.isMobile = isMobile;
    this.index = index;
    this.$container = $(el);
    this.$gallery = this.$container.find('.work__gallery');
    this.$navigation = this.$container.find('.navigation');
    this.$prev = this.$navigation.find('.navigation__prev');
    this.$next = this.$navigation.find('.navigation__next');
    this.$videos = this.$gallery.find('video');

    // options
    this.desktopOptions = {
      modules: [Navigation],
      init: false,
      spaceBetween: 5,
      navigation: {
        prevEl: this.$prev[0],
        nextEl: this.$next[0],
      },
    };

    this.mobileOptions = {
      modules: [Autoplay],
      loop: true,
      init: false,
      spaceBetween: 5,
      autoplay: {
        delay: this.autoPlayInterval,
      },
    };
    this.options = this.isMobile ? this.mobileOptions : this.desktopOptions;

    this.init();
  }

  init() {
    this.swiperInstance = new Swiper(this.$gallery[0], this.options);

    // events
    this.swiperInstance.on('init', this.slideChange.bind(this));
    this.swiperInstance.on('slideChange', this.slideChange.bind(this));

    // init
    this.swiperInstance.init();

    // loop video manually to be able detect when video ends
    this.$videos.on('ended', async (e) => {
      // if (this.isMobile) this.swiperInstance.slideNext();

      try {
        await e.target.play();
      } catch (error) {
        console.log(error);
      }
    });

    if (!this.isMobile) return;

    // if odd, stop autoplay and start with some delay
    if (this.index % 2 !== 0 && this.swiperInstance) {
      this.swiperInstance.autoplay.stop();
      setTimeout(() => {
        this.swiperInstance.autoplay.start();
      }, this.autoPlayInterval / 2);
    }
  }

  resetAnimation() {
    if (!this.isMobile) return;

    // if odd, stop autoplay and start with some delay
    if (this.index % 2 !== 0 && this.swiperInstance) {
      this.swiperInstance.autoplay.stop();
      setTimeout(() => {
        this.swiperInstance.autoplay.start();
      }, this.autoPlayInterval / 2);
    }
  }

  // autoPlay() {
  //   if (this.timer) clearTimeout(this.timer);

  //   this.timer = setTimeout(() => {
  //     this.swiperInstance.slideNext();
  //   }, this.autoPlayInterval);
  // }

  slideChange() {
    // reset video
    const { realIndex } = this.swiperInstance;
    const activeSlide = this.swiperInstance.slides[realIndex];
    if (!activeSlide) return;
    const video = activeSlide.querySelector('video');
    if (video) {
      video.currentTime = 0;
    }

    // if (this.isMobile && !video) {
    //   this.autoPlay();
    // }
  }

  destroy() {
    this.swiperInstance.destroy(true, true);
    this.swiperInstance = null;
  }
}

export default Project;
